import { Box } from '@mui/material';
// import {
//   Box, Grid, Stack, Typography, Card, CardActionArea, Radio, Divider, Alert,
//   InputAdornment, TextField, MenuItem, Table, TableHead, TableRow, TableCell,
//   TableBody, TableContainer, Paper, Button, IconButton,
// } from '@mui/material';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import AddIcon from '@mui/icons-material/Add';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   updateBlendedTc, setCodTiers, updateRto, setRtoSlab, updateRvpTcs,
//   setWeightCeiling, setInvoiceCeiling,
// } from '../../../../redux/pricingWizardSlice';
// import { refreshCodDef } from '../helpers/rateEngine';
// import { useGetServiceabilityGroupsQuery } from '../../../../redux/commonApiCalls';
// import SectionTitle from '../components/SectionTitle';
import DphFscCard from '../components/DphFscCard';

// const COD_STRUCTURES = [
//   { id: 'flat', title: 'Flat', sub: 'Single charge or MAX(fixed, %invoice). Values captured per courier/lane on Commercials.' },
//   { id: 'tiered_weight', title: 'Weight Slab Based COD', sub: 'Charge varies by shipment weight slab. Final slab must extend up to the weight ceiling.' },
//   { id: 'tiered_invoice', title: 'Invoice Value Based COD', sub: 'Charge varies by COD invoice value (e.g. <₹500 nil, ₹500–2000 ₹25…).' },
// ];
// const RTO_MODES = [
//   { id: 'fixed', title: 'Fixed ₹', sub: 'Flat amount per RTO shipment, irrespective of forward freight.' },
//   { id: 'pct_fwd', title: '% of Forward', sub: 'RTO = pct × forward rate for that zone/slab.' },
//   { id: 'slab', title: 'FWD-based slab', sub: 'Different RTO % per weight slab.' },
// ];

// function PickCard({ checked, onClick, title, sub }) {
//   return (
//     <Card variant="outlined" sx={{ height: '100%', borderColor: checked ? 'primary.main' : 'divider', bgcolor: checked ? 'primary.lighter' : 'background.paper' }}>
//       <CardActionArea onClick={onClick} sx={{ p: 1.5, height: '100%' }}>
//         <Stack direction="row" spacing={1.25} alignItems="flex-start">
//           <Radio checked={checked} sx={{ p: 0.25, pointerEvents: 'none' }} />
//           <Box><Typography variant="body2" sx={{ fontWeight: 700 }}>{title}</Typography><Typography variant="caption" sx={{ color: 'text.secondary' }}>{sub}</Typography></Box>
//         </Stack>
//       </CardActionArea>
//     </Card>
//   );
// }

// function TieredCodTable({ kind, tiers }) {
//   const dispatch = useDispatch();
//   const set = (next) => dispatch(setCodTiers({ kind, tiers: next }));
//   const minLbl = kind === 'weight' ? 'Min weight (GMS)' : 'Min invoice (₹)';
//   const maxLbl = kind === 'weight' ? 'Max weight (GMS)' : 'Max invoice (₹)';
//   const editCell = (i, k, v) => { const next = tiers.map((t, j) => (j === i ? { ...t, [k]: Number(v) || 0 } : t)); set(next); };
//   return (
//     <Box>
//       <TableContainer component={Paper} variant="outlined">
//         <Table size="small">
//           <TableHead>
//             <TableRow sx={{ '& th': { bgcolor: 'background.neutral', fontWeight: 700, fontSize: 11 } }}>
//               <TableCell>{minLbl}</TableCell><TableCell>{maxLbl}</TableCell><TableCell align="right">COD charge (₹)</TableCell><TableCell />
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {tiers.map((t, i) => (
//               <TableRow key={i}>
//                 <TableCell><TextField size="small" type="number" defaultValue={t.min} onBlur={(e) => editCell(i, 'min', e.target.value)} sx={{ width: 110 }} /></TableCell>
//                 <TableCell><TextField size="small" type="number" defaultValue={t.max} onBlur={(e) => editCell(i, 'max', e.target.value)} sx={{ width: 110 }} /></TableCell>
//                 <TableCell align="right"><TextField size="small" type="number" defaultValue={t.charge} onBlur={(e) => editCell(i, 'charge', e.target.value)} sx={{ width: 110 }} /></TableCell>
//                 <TableCell><IconButton size="small" color="error" onClick={() => set(tiers.filter((_, j) => j !== i))}><DeleteOutlineIcon fontSize="small" /></IconButton></TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Button size="small" startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => { const last = tiers[tiers.length - 1] || { min: 0, max: 0, charge: 0 }; set([...tiers, { min: last.max, max: last.max + (kind === 'weight' ? 500 : 1000), charge: 0 }]); }}>
//         Add slab
//       </Button>
//       <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.5 }}>
//         COD charge applies to shipments whose {kind === 'weight' ? 'chargeable weight' : 'COD invoice value'} falls within [Min, Max).
//       </Typography>
//     </Box>
//   );
// }

export default function Stage5_Tcs() {
  // const dispatch = useDispatch();
  // const b = useSelector((s) => s.pricingWizard.tc.blended);
  // const rto = useSelector((s) => s.pricingWizard.rto);
  // const rvpEnabled = useSelector((s) => s.pricingWizard.rvp.enabled);
  // const rvpMode = useSelector((s) => s.pricingWizard.rvp.mode);
  // const rvpTcs = useSelector((s) => s.pricingWizard.rvp.tcs);
  // const weightCeiling = useSelector((s) => s.pricingWizard.agreement.weight_ceiling);
  // const invoiceCeiling = useSelector((s) => s.pricingWizard.invoice_ceiling);
  // const codDef = refreshCodDef(b);

  return (
    <Box>
      {/* Only DPH-Linked FSC is active. All other T&C sections are commented out below. */}

      {/* DPH-Linked FSC (diesel price hike) */}
      <DphFscCard />

      {/* ── COMMENTED OUT — COD structure ──────────────────────────────────────
      <Alert severity="info" icon={<span>🚧</span>} sx={{ mb: 2 }}>
        <b>Serviceability & global guardrails.</b> COD <i>structure</i>, serviceability ceilings, the global RTO default, and (for independent RVP) RVP T&Cs.
        <b> Per-courier / per-lane pricing T&Cs — COD charge, RTO %, RVP, QC, remittance — are captured on the Commercials step</b> (single source of truth) and are not re-asked here.
      </Alert>

      <SectionTitle icon="🌐" title="Global / Blended T&Cs" />

      <Typography variant="caption" sx={{ fontWeight: 700, display: 'block', mt: 1.5, mb: 0.75 }}>COD Collection Charge — structure *</Typography>
      <Grid container spacing={1.5}>
        {COD_STRUCTURES.map((c) => (
          <Grid item xs={12} md={4} key={c.id}>
            <PickCard checked={b.cod_structure === c.id} onClick={() => dispatch(updateBlendedTc({ cod_structure: c.id }))} title={c.title} sub={c.sub} />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 1.5 }}>
        {b.cod_structure === 'flat' && (
          <Alert severity="info" icon={<span>↩</span>} sx={{ bgcolor: '#eef2ff' }}>
            Flat COD base ₹ + % + operator are set per courier (Courier-Wise) or per lane (Blended) in <b>Commercial Construct → Preview & Confirm</b>.
            Resulting blended charge: <b style={{ fontFamily: 'JetBrains Mono, monospace' }}>{codDef}</b>
          </Alert>
        )}
        {b.cod_structure === 'tiered_weight' && <TieredCodTable kind="weight" tiers={b.cod_tiers_weight} />}
        {b.cod_structure === 'tiered_invoice' && <TieredCodTable kind="invoice" tiers={b.cod_tiers_invoice} />}
      </Box>
      ────────────────────────────────────────────────────────────────────────── */}

      {/* ── COMMENTED OUT — Serviceability ceilings ────────────────────────────
      <Paper variant="outlined" sx={{ mt: 2, p: 2, borderColor: 'primary.light' }}>
        <SectionTitle icon="🚧" title="Serviceability ceilings" badge="block shipments above these limits" />
        <Grid container spacing={1.5} sx={{ mt: 0.25 }}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth size="small" type="number" label="Weight ceiling (GMS) *" value={weightCeiling || ''} placeholder="e.g. 20000"
              onChange={(e) => dispatch(setWeightCeiling(Number(e.target.value) || null))}
              helperText="Shipments above this weight are blocked at booking. Highest rate-card slab + highest COD slab must reach this." />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth size="small" type="number" label="Invoice-value ceiling (₹) *" value={invoiceCeiling || ''} placeholder="e.g. 50000"
              onChange={(e) => dispatch(setInvoiceCeiling(Number(e.target.value) || null))}
              InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
              helperText="Declared value above this is blocked — prevents unauthorised high-value parcels." />
          </Grid>
        </Grid>
      </Paper>
      ────────────────────────────────────────────────────────────────────────── */}

      {/* ── COMMENTED OUT — RTO Default ────────────────────────────────────────
      <Divider sx={{ my: 2.5 }} />
      <SectionTitle icon="↺" title="RTO Default (Global)" badge="applies to every courier unless overridden in Rate Card" />
      <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.5, mb: 1 }}>
        Pick how Return-to-Origin freight is computed globally. Individual couriers can override this in the Rate Card builder.
      </Typography>
      <Grid container spacing={1.5}>
        {RTO_MODES.map((m) => (
          <Grid item xs={12} md={4} key={m.id}>
            <PickCard checked={rto.mode === m.id} onClick={() => dispatch(updateRto({ mode: m.id }))} title={m.title} sub={m.sub} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 1.5 }}>
        {rto.mode === 'fixed' && (
          <TextField size="small" type="number" label="Fixed RTO charge (₹) *" value={rto.fixed_amount || ''} sx={{ maxWidth: 280 }}
            onChange={(e) => dispatch(updateRto({ fixed_amount: Number(e.target.value) || 0 }))}
            InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }} />
        )}
        {rto.mode === 'pct_fwd' && (
          <TextField size="small" type="number" label="RTO percentage (% of Forward) *" value={rto.pct_fwd || ''} sx={{ maxWidth: 280 }}
            onChange={(e) => dispatch(updateRto({ pct_fwd: Number(e.target.value) || 0 }))}
            InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }} helperText="If Forward = ₹100 and RTO % = 70 → RTO = ₹70." />
        )}
        {rto.mode === 'slab' && (
          <RtoSlabTable slab={rto.slab} onChange={(next) => dispatch(setRtoSlab(next))} />
        )}
      </Box>
      ────────────────────────────────────────────────────────────────────────── */}

      {/* ── COMMENTED OUT — RVP T&Cs (Mode B only) ────────────────────────────
      {rvpEnabled && rvpMode === 'independent' && <RvpTcsCard tcs={rvpTcs} dispatch={dispatch} />}
      ────────────────────────────────────────────────────────────────────────── */}
    </Box>
  );
}

// ── COMMENTED OUT — RtoSlabTable ─────────────────────────────────────────────
// function RtoSlabTable({ slab, onChange }) {
//   const editCell = (i, k, v) => onChange(slab.map((s, j) => (j === i ? { ...s, [k]: Number(v) || 0 } : s)));
//   return (
//     <Box>
//       <TableContainer component={Paper} variant="outlined">
//         <Table size="small">
//           <TableHead>
//             <TableRow sx={{ '& th': { bgcolor: 'background.neutral', fontWeight: 700, fontSize: 11 } }}>
//               <TableCell>Min weight (GMS)</TableCell><TableCell>Max weight (GMS)</TableCell><TableCell align="right">RTO factor (fraction of FWD)</TableCell><TableCell />
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {slab.map((s, i) => (
//               <TableRow key={i}>
//                 <TableCell><TextField size="small" type="number" defaultValue={s.min} onBlur={(e) => editCell(i, 'min', e.target.value)} sx={{ width: 120 }} /></TableCell>
//                 <TableCell><TextField size="small" type="number" defaultValue={s.max} onBlur={(e) => editCell(i, 'max', e.target.value)} sx={{ width: 120 }} /></TableCell>
//                 <TableCell align="right"><TextField size="small" type="number" defaultValue={s.rate} inputProps={{ step: 0.01 }} onBlur={(e) => editCell(i, 'rate', e.target.value)} sx={{ width: 120 }} /></TableCell>
//                 <TableCell><IconButton size="small" color="error" onClick={() => onChange(slab.filter((_, j) => j !== i))}><DeleteOutlineIcon fontSize="small" /></IconButton></TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Button size="small" startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => { const last = slab[slab.length - 1]; onChange([...slab, { min: last ? last.max : 0, max: last ? last.max + 1000 : 1000, rate: 0.7 }]); }}>
//         Add slab
//       </Button>
//       <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.5 }}>Factor 0.7 means "RTO = 70% of forward for that slab".</Typography>
//     </Box>
//   );
// }

// ── COMMENTED OUT — RvpTcsCard ────────────────────────────────────────────────
// function RvpTcsCard({ tcs, dispatch }) {
//   const { data: groups = [] } = useGetServiceabilityGroupsQuery();
//   const allParents = [...new Set(
//     groups.flatMap((g) => (g.linkedCodes || []).filter((c) => c.isActive !== false).map((c) => c.parent || c.cpAccountCode))
//   )].sort();
//   const charges = tcs.courier_charges || [];
//   const setCharges = (next) => dispatch(updateRvpTcs({ courier_charges: next }));
//   return (
//     <>
//       <Divider sx={{ my: 2.5 }} />
//       <SectionTitle icon="🔄" title="RVP Terms & Conditions" badge="MODE B" />
//       ...
//     </>
//   );
// }

export function validateTcs(/* wizard */) {
  // Validation commented out — only DPH-Linked FSC is active on this stage.
  // const b = wizard.tc.blended;
  // const wc = wizard.agreement.weight_ceiling;
  // if (b.cod_structure === 'tiered_weight' && wc) {
  //   const lastMax = Math.max(...b.cod_tiers_weight.map((t) => +t.max || 0));
  //   if (lastMax < wc) return { cod: `Weight Slab COD final slab (${lastMax} GMS) is below the weight ceiling (${wc} GMS).` };
  // }
  // if (!wc || +wc <= 0) return { wc: 'Weight ceiling is required.' };
  // if (!wizard.invoice_ceiling || +wizard.invoice_ceiling <= 0) return { vc: 'Invoice-value ceiling is required.' };
  return {};
}
